/**
 * useModalScrollLock — DESIGN-SYSTEM.md's Modals scroll lock: while any modal is
 * open, the page behind the overlay must not scroll (only the panel does).
 *
 * Counter-guarded, as the rule specifies: a `ConfirmModal` layered over a
 * form modal must not unlock the body when it closes first. The pre-lock
 * overflow value is captured at the first lock and restored only when the
 * last open modal closes.
 */
import { useEffect } from "react";

let lockCount = 0;
let prevOverflow = "";

export function useModalScrollLock(open: boolean): void {
  useEffect(() => {
    if (!open) return;
    if (lockCount === 0) {
      prevOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    }
    lockCount += 1;
    return () => {
      lockCount -= 1;
      if (lockCount === 0) document.body.style.overflow = prevOverflow;
    };
  }, [open]);
}
